import { render } from "./LanguageSelector.vue?vue&type=template&id=202d4788&scoped=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"

import "./LanguageSelector.vue?vue&type=style&index=0&id=202d4788&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202d4788"]])

export default __exports__